import { render, staticRenderFns } from "./couponUsageRules.vue?vue&type=template&id=36337687&scoped=true&"
import script from "./couponUsageRules.vue?vue&type=script&lang=js&"
export * from "./couponUsageRules.vue?vue&type=script&lang=js&"
import style0 from "./couponUsageRules.vue?vue&type=style&index=0&id=36337687&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36337687",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
